// ECRIT A LA MAIN, icone du fondateur (voir `./index.ts`).
import { createCustomIcon } from './create-custom-icon.js';

/**
 * Une croix pleine : ajouter une conversation depuis l'en-tete de la fenetre du centre.
 *
 * Fournie par le fondateur pendant les retouches du 06/10/2026,
 * exportee en traces Potrace : cadre `0 0 240 240`, traces en dixiemes et
 * retournes (`translate(0 240) scale(.1 -.1)`), recopies tels quels.
 */
export const IconWindowAdd = createCustomIcon(
  'IconWindowAdd',
  '0 0 240 240',
  <path fill="currentColor" transform="translate(0 240) scale(.1 -.1)" d="M1070 1815 l0 -485 -485 0 -485 0 0 -130 0 -130 485 0 485 0 0 -485 0 -485 130 0 130 0 0 485 0 485 485 0 485 0 0 130 0 130 -485 0 -485 0 0 485 0 485 -130 0 -130 0 0 -485z" />,
);
